import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  forgotPassword,
  forgotPasswordSubmit,
  IConfirmPassword,
} from "src/redux/Authentication/sliceAuthentication";
import { ForgotPasswordForm } from "src/web/features/authentication";
import { Box, Divider, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import { useHistory } from "react-router-dom";

const ForgotPassword: React.FC<{}> = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [confirmCode, setConfirmCode] = useState("");
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [isSendingCode, setIsSendingCode] = useState(false);

  const onCodeSubmit = async (username: string) => {
    if (!username) {
      return;
    }
    setIsSendingCode(true);
    try {
      const result = await dispatch(forgotPassword({ username }));
      if (result && (result as any).nextStep) {
        const nextStep = (result as any).nextStep;
        const destination = nextStep.codeDeliveryDetails?.destination || "";
        const attributeName = nextStep.codeDeliveryDetails?.attributeName || "";
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSendingCode(false);
    }
  };

  const onSubmit = async (
    data: {
      username: string;
      confirmationCode: string;
      newPassword: string;
    },
    e?: React.BaseSyntheticEvent,
  ) => {
    e?.preventDefault();
    setIsResettingPassword(true);
    try {
      const confirmData: IConfirmPassword = {
        username: data.username,
        code: data.confirmationCode,
        password: data.newPassword,
      };
      await dispatch(forgotPasswordSubmit(confirmData));
      history.push("/login");
    } catch (error) {
    } finally {
      setIsResettingPassword(false);
    }
  };

  return (
    <>
      <Box>
        <Typography className={classes.title}>Access recovery</Typography>
      </Box>
      <Box>
        <Divider style={{ backgroundColor: "#fafafa" }} />
      </Box>
      <Box mb={3}>
        <Typography className={classes.subTitle}>
          Write your username for password recovery!
        </Typography>
      </Box>

      <ForgotPasswordForm
        onSubmit={onSubmit}
        onCodeSubmit={onCodeSubmit}
        confirmCode={confirmCode}
        setConfirmCode={setConfirmCode}
        isResettingPassword={isResettingPassword}
        isSendingCode={isSendingCode}
      />
    </>
  );
};

export default ForgotPassword;
